module.exports = __webpack_public_path__ + "img/about_p2-image.b921f4c1.jpg";